export default __webpack_public_path__ + "static/media/illustration.51b6eca9.png";